module.exports = __webpack_public_path__ + "make-different-img-71b28c52.webp";